import React from 'react';
import { Chip, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

const MAX_TAGS = 10;
const MAX_TAG_LENGTH = 64;

export const TagsInput = ({
  tags,
  onChange,
  disabled,
}: {
  tags: string[];
  onChange: (tags: string[]) => void;
  disabled?: boolean;
}) => {
  const handleChange = (_: React.ChangeEvent<{}>, value: (string | string[])[]) => {
    const flat = value.flatMap(v => (Array.isArray(v) ? v : [v]));
    const validated = flat
      .map(t => t.trim().replace(/\s+/g, '-'))
      .filter(t => t.length > 0 && t.length <= MAX_TAG_LENGTH);
    onChange(validated.slice(0, MAX_TAGS));
  };

  return (
    <Autocomplete
      multiple
      freeSolo
      options={[]}
      value={tags}
      onChange={handleChange}
      disabled={disabled}
      renderTags={(value, getTagProps) =>
        value.map((tag, index) => (
          <Chip
            label={tag}
            size="small"
            style={{ height: 20, fontSize: 11 }}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={params => (
        <TextField
          {...params}
          label="Tags"
          variant="outlined"
          helperText={`${tags.length}/${MAX_TAGS} tags`}
        />
      )}
    />
  );
};
